import Dropdown from "../../../modules/dataset/components/Dropdown"

const FilterGroup = () => {
  return <div className="flex py-2">
    <div className="flex gap-3">
      <Dropdown
        className="border-2 border-[#e0e0e0] rounded-md outline-none"
        onSelect={() => { }}
        defaultValue=""
        placeholder="Chains"
        options={[
          { name: 'Chains', value: 'most-popular' },
          { name: 'Most Recent', value: 'most-recent' },
        ]}
      />
      <Dropdown
        className="border-2 border-[#e0e0e0] rounded-md outline-none"
        onSelect={() => { }}
        defaultValue=""
        placeholder="Labels"
        options={[
          { name: 'Labels', value: 'most-popular' },
          { name: 'Most Recent', value: 'most-recent' },
        ]}
      />
      <Dropdown
        className="border-2 border-[#e0e0e0] rounded-md outline-none"
        onSelect={() => { }}
        defaultValue=""
        placeholder="Business Needs"
        options={[
          { name: 'Business Needs', value: 'most-popular' },
          { name: 'Most Recent', value: 'most-recent' },
        ]}
      />
    </div>
    <div className="divider divider-horizontal py-1 mx-1" >

    </div>
    <div>
      <Dropdown
        className="border-2 border-[#e0e0e0] rounded-md outline-none"
        onSelect={() => { }}
        defaultValue="most-popular"
        placeholder="Sort by"
        options={[
          { name: 'Most Popular', value: 'most-popular' },
          { name: 'Most Recent', value: 'most-recent' },
        ]}
      />
    </div>
  </div>
}

export default FilterGroup